var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCriarEmpresa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11H10V9H12V11ZM14 11H16V9H14V11ZM13.4 21H12V17.5H10V21H4V3H18V13.1C18.3 13 18.7 13 19 13C19.3 13 19.7 13 20 13.1V1H2V23H14.5C14 22.4 13.6 21.7 13.4 21ZM14 7H16V5H14V7ZM16 13.8V13H14V15H14.5C15 14.5 15.5 14.1 16 13.8ZM8 5H6V7H8V5ZM8 9H6V11H8V9ZM6 19H8V17H6V19ZM12 5H10V7H12V5ZM10 15H12V13H10V15ZM8 13H6V15H8V13ZM18 15V18H15V20H18V23H20V20H23V18H20V15H18Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriarEmpresa);
export default __webpack_public_path__ + "static/media/CriarEmpresa.c9f92793493d3a0bf80c74fcf8f2899f.svg";
export { ForwardRef as ReactComponent };